import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrgCurrencySymbolPipe } from './org-currency-symbol.pipe';
import { OrgDatePipe } from './org-date.pipe';
import { OrgTermPipe } from './org-term.pipe';

@NgModule({
  declarations: [
    OrgCurrencySymbolPipe,
    OrgDatePipe,
    OrgTermPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    OrgCurrencySymbolPipe,
    OrgDatePipe,
    OrgTermPipe
  ]
})
export class AppPipesMdl { }
